export const CUSTOMER_GROUP_CONFIG = {
  TRADE_MEMBER_ID: parseInt(<string>process.env.NEXT_PUBLIC_BIGCOMMERCE_TRADE_GROUP_ID, 10) || 0,
};
